import React, { useState } from "react";
import "./register.scss";
import Button from "@material-ui/core/Button";
import { PATH } from "../../constants/appConstants";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { getCopy } from "../../helpers/utils.helper";
import {
  isFieldEmpty,
  isObjectEmpty,
  isPhoneNumber,
  isValidEmail,
} from "../../helpers/appFieldValidation";
import { useDispatch } from "react-redux";
import {
  errorRegisterUser,
  successRegisterUser,
} from "../../actions/snackbarActions";
import { Link } from "react-router-dom";

import { Card } from "@mui/material";
import { City, Country, State } from "country-state-city";
import MTextField from "../../components/MTextField";
import MAutocomplete from "../../components/MAutocomplete";
import MDropdown from "../../components/MDropdown";
import MPasswordField from "../../components/MPasswordField";
import { useNavigate } from "react-router";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";
import LoadingAnimation from "../../components/LoadingAnimation";

const formFields = require("./formfields.json");

export default function Register(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    showPassword: false,
    dateOfBirth: "now",
    phonecode: "(IN) 91",
  });
  const [location, setLocation] = useState({
    country: Country.getAllCountries(),
    state: [],
    city: [],
  });
  const [locationInput, setLocationInput] = useState({
    country: "",
    state: "",
    city: "",
  });
  const [locationOptions, setLocationOptions] = useState({});
  const [loadingApi, setLoadingApi] = useState(false);

  const [jamaats, setJamaats] = useState([]);
  const [registrationInProgress, setRegistrationInProgress] = useState(false);
  const [validation, setValidation] = useState([]);

  React.useEffect(() => {
    getJamatList();
  }, []);

  const handleChange = (event) => {
    let updatedUser = getCopy(user);
    updatedUser[event.target.name] = event.target.value;
    setUser(updatedUser);
  };

  const getJamatList = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_JAMAATS)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setJamaats(response.data.data);
        } else {
          dispatch(errorRegisterUser);
        }
      })
      .catch((err) => {
        dispatch(errorRegisterUser);
      });
  };

  const getCities = (country, state) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_CITIES, null, {
      state: state,
      country: country,
    })
      .then((response) => {
        if (
          response.data.status === Status.API_SUCCESS ||
          response.data.status === Status.API_NO_CONTENT
        ) {
          let city = City.getCitiesOfState(country, state);
          let newCities = city.concat(response.data.data);
          let updatedLocation = getCopy(location);
          if (newCities.length > 0) {
            updatedLocation.city = newCities.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
          } else {
            updatedLocation.city = { name: state };
          }

          setLocation(updatedLocation);
        } else {
          dispatch(errorRegisterUser);
        }
      })
      .catch((err) => {
        dispatch(errorRegisterUser);
      });
  };

  const handleDropdownChange = (value, type) => {
    
    const updatedUser = getCopy(user);
    const updatedLocation = getCopy(location);
    const updatedLocationOptions = getCopy(locationOptions);
    updatedLocationOptions[type] = value;
    let cityApiCalled = false;
    if(value===null){
      return{}
    }
    switch (type) {
      case "country":
        updatedUser.country = value.name;
        updatedUser.countryCode = value.isoCode;
        updatedUser.state = "";
        updatedUser.city = "";
        updatedLocation.state = State.getStatesOfCountry(
          updatedUser.countryCode
        );
        updatedLocation.city = [];
        break;
      case "state":
        updatedUser.state = value.name;
        updatedUser.stateCode = value.isoCode;
        updatedUser.city = "";
        updatedLocation.city = [];
        cityApiCalled = true;
        break;
      case "city":
        updatedUser.city = value.name;
        break;
      case "jamaat":
        updatedUser.jamatName = value.name;
        updatedUser.jamatCode = value.code;
        break;
      default:
        updatedUser[type] = value[type];
        break;
    }
    console.log(updatedLocation);
    setUser(updatedUser);
    setLocation(updatedLocation);
    setLocationOptions(updatedLocationOptions);
    if (cityApiCalled) {
      getCities(updatedUser.countryCode, updatedUser.stateCode);
    }
  };

  const handleClickShowPassword = () => {
    let updatedUser = getCopy(user);
    updatedUser.showPassword = !updatedUser.showPassword;
    setUser(updatedUser);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const getValidation = () => {
    const validations = formFields
      .map((field) => {
        if (getFieldRequired(field)) {
          if (field.key === "dateOfBirth") {
            if (user[field.key] === "now") {
              return {
                name: field.key,
                validation: `${field.label} is mandatory.`,
              };
            }
          }

          if (isFieldEmpty(user[field.key])) {
            if (field.key === "mobile") {
              if (isFieldEmpty(user["phonecode"])) {
                return {
                  name: "mobile",
                  titleError: true,
                  validation: "Please select country code.",
                };
              } else {
                return {
                  name: field.key,
                  validation: `${field.label} is mandatory.`,
                };
              }
            } else if (field.key === "firstName") {
              if (isFieldEmpty(user["firstName-salutation"])) {
                return {
                  name: field.key,
                  titleError: true,
                  validation: "Please select title.",
                };
              } else {
                return {
                  name: field.key,
                  validation: `${field.label} is mandatory.`,
                };
              }
            } else if (field.key === "jamaat") {
              if (isFieldEmpty(user["jamatName"])) {
                return {
                  name: field.key,
                  validation: `${field.label} is mandatory.`,
                };
              }
            } else {
              return {
                name: field.key,
                validation: `${field.label} is mandatory.`,
              };
            }
          } else {
            if (field.key === "email") {
              if (!isValidEmail(user["email"])) {
                return {
                  name: "email",
                  validation: "Please enter valid email.",
                };
              }
            } else if (field.key === "mobile") {
              if (!isPhoneNumber(user["mobile"])) {
                return {
                  name: "mobile",
                  validation: "Please enter valid phone number.",
                };
              }
            } else if (field.key === "confirmPassword") {
              if (user["password"] !== user["confirmPassword"]) {
                return {
                  name: "confirmPassword",
                  validation: "Password and confirm password should match.",
                };
              }
            }
          }
        }
        return {};
      })
      .filter((validation) => !isObjectEmpty(validation));

    setValidation(validations);

    if (validations.length > 0) {
      setRegistrationInProgress(false);
      dispatch(
        setResponsiveDialog(
          true,
          "Form errors",
          "Please resolve the errors in the form to submit it.",
          "OK"
        )
      );
    }
    return validations.length === 0;
  };

  const getCallingCode = () => {
    const country = location["country"].filter(
      (c) => "(" + c.isoCode + ") " + c.phonecode === user["phonecode"]
    );
    if (country.length > 0) {
      return country[0].phonecode;
    } else {
      return "91";
    }
  };

  const registerUser = () => {
    if (getValidation()) {
      setRegistrationInProgress(true);
      setLoadingApi(true);
      let updatedUser = getCopy(user);
      updatedUser.title = updatedUser["firstName-salutation"];
      updatedUser.countryCallingCode = getCallingCode();
      updatedUser.address = {
        society: updatedUser.society,
        street: updatedUser.street,
        landMark: updatedUser.landMark,
      };
      setUser(updatedUser);
      AjaxHelper.postApi(navigate, Endpoint.REGISTER_USER, updatedUser)
        .then((response) => {
          setRegistrationInProgress(false);
          setLoadingApi(false);
          if (response.data.status === Status.API_SUCCESS) {
            dispatch(successRegisterUser);
            displayInfo(response.data.data.userCode);
          } else {
            dispatch(errorRegisterUser);
          }
        })
        .catch((err) => {
          setRegistrationInProgress(false);
          setLoadingApi(false);
          dispatch(errorRegisterUser);
        });
    }
  };

  const getFieldDisable = (field) => {
    if (field.disabled === undefined) {
      return false;
    }

    if (field.disabled.condition === undefined) {
      return field.disabled.value;
    }

    const conditionFields = field.disabled.condition.fields;
    const conditionArray = [];
    conditionFields.forEach((conditionField) => {
      const fieldValue = user[conditionField.key];
      conditionArray.push(!conditionField.values.includes(fieldValue));
    });

    return !conditionArray.includes(false);
  };

  const getFieldRequired = (field) => {
    const disabled = getFieldDisable(field);
    if (disabled) {
      return false;
    } else {
      return field.required;
    }
  };

  const getRegisterFields = () => {
    return formFields.map((field) => {
      if (field.type === "password") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MPasswordField
              id={field.key}
              name={field.key}
              key={field.key}
              label={field.label}
              className="input"
              required={getFieldRequired(field)}
              type={user.showPassword ? "text" : "password"}
              onChange={handleChange}
              onClickShowPassword={handleClickShowPassword}
              onClickMouseDownPassword={handleMouseDownPassword}
              showPassword={user.showPassword}
              error={getFieldError(field.key)}
              placeholder={field.placeholder}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "dropdown") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MDropdown
              id={field.key}
              key={field.key}
              className={"input"}
              required={getFieldRequired(field)}
              label={field.label}
              name={field.key}
              value={user[field.key]}
              onChange={handleChange}
              placeholder={field.placeholder}
              options={field.options}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "text") {
        if (field.salutation) {
          return (
            <div
              className={
                (field.size === "half"
                  ? "col-xl-6 col-lg-12 col-md-12"
                  : "col-xl-3 col-lg-6 col-md-12") +
                "  col-12 d-flex justify-content-center align-items-center"
              }
            >
              <div className={"col-3"}>
                <MDropdown
                  id={field.key + "-salutation"}
                  key={field.key + "-salutation"}
                  required={getFieldRequired(field)}
                  label={"Title"}
                  name={field.key + "-salutation"}
                  value={user[field.key + "-salutation"]}
                  onChange={handleChange}
                  placeholder={""}
                  options={field.salutation}
                  error={getFieldTitleError(field.key)}
                  helperText={getFieldTitleError(field.key) ? "Error" : ""}
                />
              </div>
              <div className="col-9">
                <MTextField
                  id={field.key}
                  name={field.key}
                  required={getFieldRequired(field)}
                  label={field.label}
                  value={user[field.key]}
                  onChange={handleChange}
                  disabled={getFieldDisable(field)}
                  error={getFieldError(field.key)}
                  placeholder={field.placeholder}
                  helperText={getFieldErrorText(field.key)}
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              className={
                (field.size === "half"
                  ? "col-xl-6 col-lg-12 col-md-12"
                  : "col-xl-3 col-lg-6 col-md-12") +
                "  col-12 d-flex justify-content-center align-items-center"
              }
            >
              <MTextField
                id={field.key}
                name={field.key}
                className="col-12"
                required={getFieldRequired(field)}
                label={field.label}
                value={user[field.key]}
                onChange={handleChange}
                disabled={getFieldDisable(field)}
                error={getFieldError(field.key)}
                placeholder={field.placeholder}
                helperText={getFieldErrorText(field.key)}
              />
            </div>
          );
        }
      } else if (
        field.type === "country" ||
        field.type === "state" ||
        field.type === "city"
      ) {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MAutocomplete
              id={field.key}
              value={locationOptions[field.key]}
              key={field.key}
              inputValue={user[field.key]}
              size="medium"
              className="input"
              required={field.required}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type)
              }
              onInputChange={(event, newInputValue) => {
                const updatedUser = getCopy(user);
                updatedUser[field.key] = newInputValue;
                setUser(updatedUser);
              }}
              options={location[field.type]}
              placeholder={field.placeholder}
              label={field.label}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "datepicker") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MTextField
              id={field.key}
              name={field.key}
              key={field.key}
              className="input"
              required={getFieldRequired(field)}
              label={field.label}
              variant="filled"
              value={user[field.key]}
              type={"date"}
              onChange={handleChange}
              disabled={getFieldDisable(field)}
              error={getFieldError(field.key)}
              placeholder={field.placeholder}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "jamaat") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MAutocomplete
              id={field.key}
              size="medium"
              className="input"
              key={field.key}
              required={field.required}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type)
              }
              options={jamaats}
              placeholder={field.placeholder}
              label={field.label}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "mobile") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <div className="col-md-3 col-5">
              <MDropdown
                id={field.key + "-calling"}
                key={field.key + "-calling"}
                className={"input"}
                required={getFieldRequired(field)}
                label={"Code"}
                name={"phonecode"}
                value={user["phonecode"]}
                onChange={handleChange}
                placeholder={field.placeholder}
                options={location["country"].map(
                  (c) => "(" + c.isoCode + ") " + c.phonecode
                )}
                error={getFieldTitleError(field.key)}
                helperText={getFieldTitleError(field.key) ? "Error" : ""}
              />
            </div>
            <div className="col-md-9 col-7">
              <MTextField
                id={field.key}
                name={field.key}
                className="col-12"
                required={getFieldRequired(field)}
                label={field.label}
                value={user[field.key]}
                type={"number"}
                inputProps={{ maxLength: field.numberOfCharacters }}
                onChange={handleChange}
                disabled={getFieldDisable(field)}
                placeholder={field.placeholder}
                error={getFieldError(field.key)}
                helperText={getFieldErrorText(field.key)}
              />
            </div>
          </div>
        );
      }
    });
  };

  const getDropdownData = (type) => {
   
    switch (type) {
      case "country":
        return Country.getAllCountries();
      case "state":
        return State.getStatesOfCountry(user.countryCode);
      case "city":
        return City.getCitiesOfState(user.countryCode, user.stateCode);
      default:
        return [];
    }
  };

  const displayInfo = (userCode) => {
    let message =
      getCallingCode() === "91"
        ? `Your created Memon ID is ${userCode}. The OTP is send to your phone ${user.mobile}`
        : `Your created Memon ID is ${userCode}. The OTP is send to your email ${user.email}`;
    dispatch(
      setResponsiveDialog(true, "Info", message, "OK", "", () => {
        if (getCallingCode() === "91") {
          navigate(PATH.VERIFY_PHONE, {
            replace: true,
            state: { mobile: user.mobile, userCode },
          });
        } else {
          navigate(PATH.VERIFY_EMAIL, {
            replace: true,
            state: { email: user.email, userCode },
          });
        }
      })
    );
  };

  const getFieldError = (key) => {
    const vField = validation.filter((v) => v.name === key);
    return vField.length > 0;
  };

  const getFieldErrorText = (key) => {
    const vField = validation.filter((v) => v.name === key);
    if (vField.length > 0) {
      return vField[0].validation;
    } else {
      return "";
    }
  };

  const getFieldTitleError = (key) => {
    const vField = validation.filter((v) => v.name === key);
    if (vField.length > 0) {
      return vField[0].titleError ? vField[0].titleError : false;
    } else {
      return false;
    }
  };

  return (
    <div className="component-register d-flex justify-content-start flex-column">
      {loadingApi ? <LoadingAnimation /> : null}
      <div className="brand-bg-inverse-color mb-3 col-12">
        <div className="container">
          <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
            <Link to={"/"} className="navbar-brand">
              <img
                src={require("../../assets/logo.png")}
                alt=""
                width={"140px"}
              />
            </Link>
          </nav>
        </div>
      </div>
      <div className="inner-div">
        <Card variant={"outlined"} className="register-card my-5 col-md-8">
          <div className="card-header">Registration form</div>
          <div className="card-body">
            <div className="form">{getRegisterFields()}</div>
          </div>
          <div className="card-footer">
            <Button
              variant="contained"
              color="primary"
              className={"button"}
              disabled={registrationInProgress}
              onClick={() => {
                registerUser();
              }}
            >
              Submit
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
